import { t } from 'i18next';
import { Component, ReactElement } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from '../../../../../../../shared/common/types/common';
import { createActionSetError, TError } from '../../../../../../../shared/frontend/scripts/actions/errorActions';
import NewsListActionCreator from '../../../actions/newsListActionCreator';
import frontendLog from '../../../libs/frontendLog';
import { TApplicationState } from '../../../libs/store';
import { areFieldsDifferent } from '../../../../../../../shared/frontend/libs/utils';
import apiService from '../../../services/apiService';

/* tslint:disable:max-line-length */

type TPropsFromState = {
  details?: any;
  isLoading?: boolean;
  isLoaded?: boolean;
};

type TPropsThatDispatch = {
  setNewsListContent(params: any): void;
  setNewsListLoading(loading: boolean): void;
  showError(actionData: TError): void;
};

type TOwnProps = {
  limit?: number;
  mobileLimit?: number; // how many to show on mobile
  mode?: string;
  tag: string[];
  user: string;
  page: number;
};

export type TNewsListLoaderProps = TOwnProps &
  TPropsFromState &
  Partial<TPropsThatDispatch> &
  RouteComponentProps<any, any>;

class NewsListLoader extends Component<any, any> {
  public render(): ReactElement<any> {
    return <this.props.component {...this.props} />;
  }
}

// take state from store and convert into props
function mapStateToProps(state: TApplicationState, ownProps: any): TPropsFromState {
  return {
    ...state.newsList,
    currentFeatures: state.currentFeatures
  };
}

// return props that need access to `dispatch` function (props that can modify the store?)
function mapDispatchToProps(dispatch: Function, ownProps: TNewsListLoaderProps): TPropsThatDispatch {
  return {
    setNewsListContent(params: any) {
      dispatch(NewsListActionCreator.setNewsListContent(params));
    },
    setNewsListLoading(loading: boolean) {
      dispatch(NewsListActionCreator.setNewsListLoading(loading));
    },
    showError(actionData: TError) {
      dispatch(createActionSetError(actionData));
    }
  };
}

// return one entire set of props
function mergeProps(stateProps: any, dispatchProps: TPropsThatDispatch, ownProps: TOwnProps) {
  const loadParams: any = {
    mode: ownProps.mode || '',
    limit: ownProps.limit || 20,
    tag: ownProps.tag || '',
    user: ownProps.user || '',
    p: ownProps.page || 0
  };

  const contentChanged = !stateProps.ui || areFieldsDifferent(['tag', 'user', 'p', 'limit'], loadParams, stateProps.ui);

  if (!stateProps.isLoading && contentChanged) {
    dispatchProps.setNewsListLoading(true);

    apiService.getNewsListContent(loadParams, (err: any, result?: any) => {
      if (err) {
        dispatchProps.showError({
          title: t('common:errors.something-went-wrong'),
          body: err.toString()
        });
        frontendLog.error({ err }, 'getNewsListContent failed');
        return;
      }

      if (!result) {
        dispatchProps.showError({
          title: t('common:errors.something-went-wrong'),
          body: t('common:errors.unable-to-load-data-reload')
        });
        frontendLog.error('getNewsListContent empty');
        return;
      }

      dispatchProps.setNewsListContent(result);
      dispatchProps.setNewsListLoading(false);
    });
  }

  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps
  };
}

export default connect<TPropsFromState, TPropsThatDispatch, TNewsListLoaderProps>(
  mapStateToProps as any,
  mapDispatchToProps,
  mergeProps as any
)(NewsListLoader as any);
